<lib-page-layout>
  <lib-title-navbar pageHeader title="Zaproś dawnych graczy"></lib-title-navbar>
  <lib-hosted-invitations-list></lib-hosted-invitations-list>
</lib-page-layout>
